import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateEmpStatusPayload {
  name: string;
  status: number;
}

export interface UpdateEmpStatusPaylod extends CreateEmpStatusPayload {}

export const EMPSTATUS_QUERY_KEY = ["employment-status"];
export const VIEW_EMPSTATUS_QUERY_KEY = ["view-employee-status"];

export const employeeStatusService = {
  createEmployeeStatus: async (payload: CreateEmpStatusPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/employment-status", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showEmployeeStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/employment-status/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateEmployeeStatus: async (id: number, payload: UpdateEmpStatusPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/employment-status/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/employment-status/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  viewAllEmployeeStatus: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-employment-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
